import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { STATS } from "../content";

export default function Research() {
  return (
    <section data-testid="research-section" className="py-28 md:py-36 px-4 sm:px-6 max-w-6xl mx-auto border-t border-border">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="font-mono text-xs tracking-[0.35em] text-gold mb-6"
      >
        03 — THE RESEARCH
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1 }}
        className="font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-6"
      >
        You're not alone in this.
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.2 }}
        className="text-muted-foreground text-base md:text-lg max-w-2xl mb-16"
        data-testid="research-intro"
      >
        This isn't weakness. It's what the job does to people when they do it alone.
      </motion.p>

      <div className="grid md:grid-cols-3 border border-border">
        {STATS.map((s, i) => (
          <motion.div
            key={s.value}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12 }}
            className={`flex flex-col p-10 hover:bg-secondary/40 transition-colors duration-500 ${
              i < STATS.length - 1 ? "border-b md:border-b-0 md:border-r border-border" : ""
            }`}
            data-testid={`stat-card-${i}`}
          >
            <span className="font-serif text-5xl sm:text-6xl font-light text-gold mb-6" data-testid={`stat-value-${i}`}>
              {s.value}
            </span>
            <p className="text-bone/85 leading-relaxed flex-1 mb-8">{s.text}</p>
            {s.url && (
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`stat-source-${i}`}
                className="inline-flex items-center gap-1.5 font-mono text-[11px] tracking-[0.15em] text-muted-foreground hover:text-gold transition-colors duration-300"
              >
                SOURCE: {s.source.toUpperCase()}
                <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
              </a>
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}
